module.exports = __webpack_public_path__ + "static/media/flume.d8b22150.jpg";